import { Button } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

import { GapBox } from 'components/Box'
import Filter, { FilterValue } from 'components/Filter'
import { TextLink } from 'components/Link'
import Paper from 'components/Paper'
import { TableHeader } from 'components/Table'
import { ProtectionTable as Table } from 'features/globalSetup/pages/Prebid/Protection/pages/ProtectionListPage/ProtectionTable'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'
import { KNOWLEDGE_BASE } from './constants'

export const ProtectionListPage = () => {
  const ability = useAbility()
  const navigate = useNavigate()
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation(['features/globalSetup', 'common'])
  const [filters, setFilters] = useState<FilterValue[]>([])

  const ProtectionFilter = (
    <Filter
      id='protection-filter'
      onChange={setFilters}
      placeholder={t('prebid.protection.list.filter')}
      values={filters}
    />
  )

  const AddButton = (): JSX.Element => (
    <Button
      data-cy='protection-add-button'
      onClick={(): void =>
        navigate(generatePath(ROUTES.GLOBAL_SETUP.PREBID.PROTECTION.ADD, { workspaceId }))
      }
      variant='contained'
    >
      {t('common:actions.addNew')}
    </Button>
  )

  return (
    <Paper>
      <TableHeader
        actions={
          ability.can('access', 'GlobalSetupPage-prebid-protection-add') ? <AddButton /> : undefined
        }
        description={t('prebid.protection.list.description')}
        descriptionEndAdornment={
          <TextLink
            link={{
              title: t('common:learnMore'),
              url: KNOWLEDGE_BASE.PROTECTION,
            }}
          />
        }
        filter={ProtectionFilter}
        title={t('prebid.protection.list.title')}
      />

      <GapBox />

      <Table filters={filters} />
    </Paper>
  )
}
